import type { Postcard } from "../postcards/Postcards.ts"

import * as UI from "@iyk/ui"

export type Theme = typeof Postcard.Theme.Encoded

export const classNameForThemedText = UI.cva(["opacity-70"], {
  variants: {
    theme: {
      Silver: ["text-black"],
      Natural: ["text-black"],
      Graphite: ["text-white"],
    },
  },
})

export function setThemeTo(theme: "light" | "dark") {
  return theme
}
